import dayjs from 'dayjs';
import { storageBaseUrl } from '../common/utils/common.utils';

import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);
export const formateDateShow = (date: string | null | undefined) => {
  if (!date) return null;
  return dayjs(date).format('DD-MM-YYYY');
};

export const setDate = (date?: Date | string | undefined | null) => {
  if (!date) return undefined;
  return dayjs(date);
};

export const formateDatePost = (date: string | null | undefined) => {
  if (!date) return undefined;
  return dayjs(date).format('YYYY-MM-DD');
};

// export function formatDateRangeArray(dates: any) {
//   const formatDate = (date: any) => (date ? date.toISOString().split('T')[0] : null);
//   if (!Array.isArray(dates) || dates.length !== 2) {
//     return { from_date: null, to_date: null };
//   }

//   const [date1, date2] = dates.map((item) => item?.$d || null);

//   return {
//     from_date: formatDate(date1),
//     to_date: formatDate(date2),
//   };
// }

export function formatDateRangeArray(dates: any) {
  const timeZone = 'Asia/Dhaka';

  const formatToBD = (date: any) => {
    if (!date) return null;

    const d = dayjs(date?.$d || date).tz(timeZone);
    return d.format('YYYY-MM-DD');
  };

  if (!Array.isArray(dates) || dates.length !== 2) {
    return { from_date: null, to_date: null };
  }

  const [date1, date2] = dates;

  return {
    from_date: formatToBD(date1),
    to_date: formatToBD(date2),
  };
}
export function parseDateRangeObject({
  from_date,
  to_date,
}: {
  from_date: string | null;
  to_date: string | null;
}) {
  const date1 = from_date ? dayjs(from_date) : undefined;
  const date2 = to_date ? dayjs(to_date) : undefined;

  return date1 && date2 ? [date1, date2] : [undefined, undefined];
}

export const getTotalDays = (dateRange?: string) => {
  if (!dateRange?.[0] || !dateRange?.[1]) return 0;

  const checkIn = dayjs(dateRange[0]);
  const checkOut = dayjs(dateRange[1]);

  return checkOut.diff(checkIn, 'days');
};

export function isNotEmptyObject(obj: any) {
  if (!obj || typeof obj !== 'object') {
    return false;
  }
  const { current, pageSize, ...rest } = obj;
  return Object.keys(rest).length > 0;
}

//  Create FormData
export const createFormData = <T>(data: T, formData: FormData): FormData => {
  Object.entries(data as Record<string, any>).forEach(([key, value]) => {
    if (Array.isArray(value) && value.length > 0) {
      // Check if array items have `originFileObj`
      if (value[0]?.originFileObj) {
        formData.append(key, value[0].originFileObj);
      }
    } else if (value !== undefined && value !== null && value !== '') {
      formData.append(key, value as string | Blob);
    }
  });

  return formData;
};

export const getImageUrl = (link?: string) => (link ? storageBaseUrl + link : null);
